import { TypesProvider } from './typesContext'

import React, { FC, ReactNode } from 'react'

interface IContextWrapperProps {
  children: ReactNode
}

const ContextWrapper: FC<IContextWrapperProps> = ({ children }) => {
  // element to wrap all useContext
  return <TypesProvider>{children}</TypesProvider>
}

export default ContextWrapper
